import { chain } from 'lodash';
import { TachographWorkingMode } from '../../enums/tachograph-working-mode';
import type { Tachograph } from '../../interfaces/common/tachograph';
import type { TelematicsDriver } from '../../interfaces/telematics/telematics-driver';
import type { TelematicsFleetData } from '../../interfaces/telematics/telematics-event';

export class TelematicsDriverFactory {
  public static from(data: {
    fleet: TelematicsFleetData;
    tachographs: ReadonlyMap<string, Tachograph>;
  }): TelematicsDriver[] {
    return chain(data.fleet.drivers)
      .values()
      .compact()
      .orderBy(({ tachograph }) =>
        tachograph?.workingMode
          ? Object.values(TachographWorkingMode).indexOf(tachograph.workingMode)
          : Infinity,
      )
      .map((driver) => ({
        ...driver,
        tachograph: data.tachographs.get(driver.uuid) ?? driver.tachograph,
      }))
      .value();
  }
}
